const LoadingPage = () => {
    return <div className='h-screen w-screen pb-[5%] flex items-center justify-center'>
        <div className='flex flex-col items-center'>
            <div className='logo'></div>
            <div className=' text-[36px] font-[600] colorMain'>OCEAN PLANNER</div>
            <div className='mt-2 flex'>
                <span className="logo-loading" />
            </div>
        </div>
    </div>
}

export default LoadingPage;